import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatureFlag } from '../contexts/SystemContext';

export default function ClinicaModuleGuard({ children }: { children: React.ReactNode }) {
  const habilitado = useFeatureFlag('modulo_clinica_habilitado');

  if (!habilitado) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
